// extracted by mini-css-extract-plugin
module.exports = {"Page":"FavoritePlace_Page__2g7JR","FilterInput":"FavoritePlace_FilterInput__1pexU"};